<template>
  <v-app>
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
              >
                Search Form
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <v-form @submit.prevent="submit">
                  <v-row class="pa-2">
                    <v-col lg="2" md="3" cols="12">
                      <v-date-input
                        input-format="dd/mm/yyyy"
                        label="From Date"
                        density="compact"
                        prepend-icon=""
                        prepend-inner-icon="mdi mdi-calendar-month"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="from_date.value.value"
                        :error-messages="from_date.errorMessage.value"
                        autocomplete="off"
                        clearable
                      ></v-date-input>
                    </v-col>

                    <v-col lg="2" md="3" cols="12">
                      <v-date-input
                        input-format="dd/mm/yyyy"
                        label="To Date"
                        density="compact"
                        prepend-icon=""
                        prepend-inner-icon="mdi mdi-calendar-month"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="to_date.value.value"
                        :error-messages="to_date.errorMessage.value"
                        autocomplete="off"
                        clearable
                      ></v-date-input>
                    </v-col>

                    <v-col lg="3" md="4" cols="12">
                      <v-autocomplete
                        label="Supplier"
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="supplier_id.value.value"
                        :items="supplierOptions"
                        :item-title="(item) => item.supplier_name"
                        item-value="id"
                        clearable
                        autocomplete="off"
                      ></v-autocomplete>
                    </v-col>

                    <v-col lg="2" md="3" cols="12">
                      <v-btn
                        class="bg-brand w-100"
                        type="submit"
                        ref="searchButton"
                      >
                        Search
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-form>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>

    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-expansion-panels v-model="panel2">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
              >
                Supplier Payment Records
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <v-row class="py-2">
                  <v-col md="4" cols="12">
                    <v-text-field
                      v-model="search"
                      append-inner-icon="mdi-magnify"
                      label="Search"
                      single-line
                      hide-details
                      density="compact"
                      variant="outlined"
                      bg-color="grey-lighten-4"
                      class="pl-2"
                      clearable
                    ></v-text-field>
                  </v-col>

                  <v-col md="4" cols="12">
                    <div class="d-flex align-center flex-column">
                      <v-btn-group
                        variant="outlined"
                        density="compact"
                        size="x-small"
                        divided
                      >
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="success"
                          @click="exportToCSV"
                        >
                          CSV
                        </v-btn>
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="primary"
                          @click="exportToExcel"
                        >
                          EXCEL
                        </v-btn>
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="red"
                          @click="exportToPDF"
                        >
                          PDF
                        </v-btn>
                      </v-btn-group>
                    </div>
                  </v-col>

                  <v-col md="4" cols="12">
                    <div class="text-right">
                      <!-- No create button for payments - they are created from invoices -->
                    </div>
                  </v-col>
                </v-row>

                <v-data-table
                  :headers="headers"
                  :items="paymentList"
                  :loading="tableLoading"
                  v-model:items-per-page="itemsPerPage"
                  :search="search"
                  :hover="true"
                  density="compact"
                >
                  <template v-slot:item.index="{ index }">
                    {{ ++index }}
                  </template>

                  <template v-slot:item.payment_date="{ item }">
                    {{ formatDateView(item.payment_date) }}
                  </template>

                  <template v-slot:item.next_payment_date="{ item }">
                    {{ formatDateView(item.next_payment_date) }}
                  </template>

                  <template v-slot:item.amount="{ item }">
                    {{ $numberFormat(item.amount) }}
                  </template>

                  <template v-slot:item.discount="{ item }">
                    {{ $numberFormat(item.discount || 0) }}
                  </template>

                  <template v-slot:item.net_payment="{ item }">
                    {{ $numberFormat(item.net_payment) }}
                  </template>

                  <template v-slot:item.payment_type="{ item }">
                    <v-chip
                      :color="getPaymentTypeColor(item.payment_type)"
                      size="small"
                      class="text-capitalize"
                    >
                      {{ formatPaymentType(item.payment_type) }}
                    </v-chip>
                  </template>

                  <template v-slot:item.status="{ item }">
                    <v-chip
                      :color="statusMap[item.status]?.color || 'grey'"
                      size="small"
                      class="text-capitalize"
                    >
                      {{ statusMap[item.status]?.label || "Unknown" }}
                    </v-chip>
                  </template>

                  <template v-slot:item.actions="{ item }">
                    <v-icon
                      class="me-2"
                      color="blue"
                      @click="viewPaymentDetails(item)"
                      title="View Payment Details"
                    >
                      mdi-eye-outline
                    </v-icon>
                  </template>
                </v-data-table>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { ref } from "vue";
import { toast } from "vue3-toastify";
import formattedDate from "@/plugins/dateFormatter";
import { formatDateView, formatDateDash } from "@/plugins/helpers";
import statusMap from "@/utils/statusMap";

export default {
  data: () => ({
    panel: [0],
    panel2: [0],
    itemsPerPage: 10,
    search: "",
    statusMap,
    headers: [
      { title: "#SL", align: "center", key: "index", width: "5%", sortable: false },
      { title: "Payment Date", align: "center", key: "payment_date", sortable: true },
      {
        title: "Invoice Code",
        align: "left",
        key: "pur_invoice.code",
        sortable: true,
      },
      {
        title: "Supplier",
        align: "left",
        key: "supplier.supplier_name",
        sortable: true,
      },
      {
        title: "Payment Type",
        align: "center",
        key: "payment_type",
        sortable: true,
      },
      {
        title: "Amount",
        align: "end",
        key: "amount",
        sortable: true,
      },
      {
        title: "Discount",
        align: "end",
        key: "discount",
        sortable: false,
      },
      {
        title: "Net Payment",
        align: "end",
        key: "net_payment",
        sortable: true,
      },
      {
        title: "Next Payment Date",
        align: "center",
        key: "next_payment_date",
        sortable: true,
      },
      {
        title: "Status",
        align: "center",
        key: "status",
        sortable: true,
      },
      {
        title: "Actions",
        align: "center",
        key: "actions",
        sortable: false,
        width: "10%",
      },
    ],
  }),
  created() {
    if (!this.$store.getters.getSupplierList.length) {
      this.$store.dispatch("getSupplierList").catch(() => {});
    }
  },
  
  computed: {
    paymentList() {
      return this.$store.getters.getSupplierPaymentList || [];
    },
    supplierOptions() {
      return this.$store.getters.getSupplierList || [];
    },
  },
  setup() {
    const store = useStore();
    const tableLoading = ref(false);

    const { handleSubmit } = useForm({
      validationSchema: yup.object({}),
    });

    const from_date = useField("from_date");
    const to_date = useField("to_date");
    const supplier_id = useField("supplier_id");

    const submit = handleSubmit((values) => {
      tableLoading.value = true;
      values.from_date = from_date.value.value ? formattedDate(from_date.value.value) : null;
      values.to_date = to_date.value.value ? formattedDate(to_date.value.value) : null;
      values.supplier_id = supplier_id.value.value || null;

      store
        .dispatch("getPurchaseSupplierPayments", values)
        .then(() => {
          tableLoading.value = false;
        })
        .catch((error) => {
          tableLoading.value = false;
          toast.error(
            error?.response?.data?.message || "Failed to load supplier payments"
          );
        });
    });

    return {
      submit,
      from_date,
      to_date,
      supplier_id,
      tableLoading,
    };
  },
  methods: {
    formatDateView,
    formatPaymentType(type) {
      const typeMap = {
        CASH: "Cash",
        BANK: "Bank",
        MOBILE_BANKING: "Mobile Banking",
      };
      return typeMap[type] || type;
    },
    getPaymentTypeColor(type) {
      const colorMap = {
        CASH: "green",
        BANK: "blue",
        MOBILE_BANKING: "purple",
      };
      return colorMap[type] || "grey";
    },
    viewPaymentDetails(item) {
      // Navigate to linked Accounts Payment Voucher using voucher_master id
      if (item.voucher_master && item.voucher_master.id) {
        this.$router.push({
          name: "view-payment-voucher",
          params: { id: item.voucher_master.id },
        });
      } else {
        toast.info("Payment voucher not found for this supplier payment");
      }
    },
    exportToPDF() {
      let serial = 1;
      const columns = [
        "#SL",
        "Payment Date",
        "Invoice Code",
        "Supplier",
        "Payment Type",
        "Amount",
        "Discount",
        "Net Payment",
        "Status",
      ];
      const rows = this.paymentList.map((item) => [
        serial++,
        this.formatDateView(item.payment_date),
        item.purInvoice?.code || "",
        item.customer?.supplier_name || "",
        this.formatPaymentType(item.payment_type),
        this.$numberFormat(item.amount),
        this.$numberFormat(item.discount || 0),
        this.$numberFormat(item.net_payment),
        this.statusMap[item.status]?.label || "Unknown",
      ]);
      this.$exportTableToPDF(
        columns,
        rows,
        "Supplier Payment Records",
        "supplier_payment_record_" + this.$fileDate(),
        "landscape"
      );
    },
    exportToExcel() {
      const data = [
        [
          "#SL",
          "Payment Date",
          "Invoice Code",
          "Supplier",
          "Payment Type",
          "Amount",
          "Discount",
          "Net Payment",
          "Next Payment Date",
          "Status",
        ],
      ];
      let serial = 1;
      this.paymentList.forEach((item) => {
        data.push([
          serial++,
          this.formatDateView(item.payment_date),
          item.purInvoice?.code || "",
          item.customer?.supplier_name || "",
          this.formatPaymentType(item.payment_type),
          this.$numberFormat(item.amount),
          this.$numberFormat(item.discount || 0),
          this.$numberFormat(item.net_payment),
          this.formatDateView(item.next_payment_date),
          this.statusMap[item.status]?.label || "Unknown",
        ]);
      });
      this.$exportTableToExcel(
        data,
        "supplier_payment_record_" + this.$fileDate()
      );
    },
    exportToCSV() {
      const data = [
        [
          "#SL",
          "Payment Date",
          "Invoice Code",
          "Supplier",
          "Payment Type",
          "Amount",
          "Discount",
          "Net Payment",
          "Next Payment Date",
          "Status",
        ],
      ];
      let serial = 1;
      this.paymentList.forEach((item) => {
        data.push([
          serial++,
          this.formatDateView(item.payment_date),
          item.purInvoice?.code || "",
          item.customer?.supplier_name || "",
          this.formatPaymentType(item.payment_type),
          this.$numberFormat(item.amount),
          this.$numberFormat(item.discount || 0),
          this.$numberFormat(item.net_payment),
          this.formatDateView(item.next_payment_date),
          this.statusMap[item.status]?.label || "Unknown",
        ]);
      });
      this.$exportTableToCSV(
        data,
        "supplier_payment_record_" + this.$fileDate()
      );
    },
  },
  mounted() {
    this.panel2 = [0];
    // Set default dates to today
    const today = new Date();
    const oneMonthBack = new Date();
    oneMonthBack.setMonth(today.getMonth() - 1);
    this.from_date.value.value = oneMonthBack;
    this.to_date.value.value = today;
    this.$nextTick(() => {
      // Auto-search on mount to load today's payments
      if (this.$refs.searchButton) {
        this.$refs.searchButton.$el.click();
      }
    });
  },
};
</script>

